import type { FeatureDetails } from './types';

/**
 * To add a new feature:
 *
 * 1. Add the feature to the FeatureName type.
 *
 * 2. Add the feature to the FEATURES object. Include its traffic type and any
 *   attributes that will be passed to Split when it's evaluated.
 *
 * 3. Add getters to ATTRIBUTE_GETTERS for any new attributes. Add relevant
 *   context to useAttributesContextualInfo if necessary
 *
 * 4. Add the feature to the FeatureReturns interface. Include the possible
 *   treatments and, if necessary, the shape of the returned config object once
 *   it's been parsed from JSON.
 */
export type Feature =
  | 'cvr_consolidate_me_pages'
  | 'cvr_me_page_terms_privacy_checkbox'
  | 'cvr_treats_in_checkout_ui';

export const FEATURES: Record<Feature, FeatureDetails> = {
  cvr_consolidate_me_pages: {
    trafficType: 'anonymous',
  },

  cvr_me_page_terms_privacy_checkbox: {
    trafficType: 'anonymous',
  },

  cvr_treats_in_checkout_ui: {
    trafficType: 'user',
    attributes: new Set(['pcode', 'isDiy']),
  },
} as const;

type ToggleTreatment = 'off' | 'on';

export interface FeatureReturns {
  cvr_consolidate_me_pages: {
    treatment: ToggleTreatment;
    config: undefined;
  };

  cvr_me_page_terms_privacy_checkbox: {
    treatment: ToggleTreatment;
    config: undefined;
  };

  cvr_treats_in_checkout_ui: {
    treatment: 'off' | 'page';
    config: undefined;
  };
}
